import React, { useContext } from 'react'
import DosageSelection from './DosageSelection'
import ProductItemSelection from './ProductItemSelection'
import { ReturingCustomersLayoutContext } from '../ReturningCustomersLayout';
import SubscriptionSelection from './SubscriptionSelection';
import SubmitButton from './SubmitButton';
import { CatalogSettingContext } from '../../ChooseTreatmentRouter';
import { clientConfig } from '../../../../config'
import * as translator from "../../../../utils/translator";
import { titleWithDosageForm } from '../dosageForm';


const COL_DESIGN_COUNTRIED = ['FR', 'CH']



const NoTreatmentSelectedInfo = () => { //HARD CODED IN FRENCH, feel free to change
  return <div className="noPreferenceInfo-container">
    <div className="noPreferenceInfo-texts">
      <p className="noPreferenceInfo-title">
        Informations pour Aucune préférence de traitement
      </p>

      <p className="noPreferenceInfo-description">
        En choisissant cette option, le médecin vous prescrira le traitement
        le plus adapté en fonction des réponses fournies dans votre
        questionnaire médical.
      </p>
    </div>
  </div>
}


interface TreatmentSelectionProps {
  isResponsiveLayout?: boolean
}
const TreatmentSelection:React.FC<TreatmentSelectionProps> = ({isResponsiveLayout = false}) => {

  const context = useContext(ReturingCustomersLayoutContext);
  const routerContext = useContext(CatalogSettingContext) as any;
  const groupedProducts = context?.groupedProducts!
  const selectedCatalogID = context?.selectedCatalogID;
  const products = selectedCatalogID ? groupedProducts[selectedCatalogID] : [];
  const selectedProduct = context?.selectedProduct;
  const productItemToPlan = context?.productItemToPlan;
  const selectedProductItemID = context?.selectedProductItemID;
  const isExpressProductItem = context?.isExpressProductItem;
  const plans = productItemToPlan && productItemToPlan[selectedProductItemID || 0];
  const selectedItem = selectedProduct?.items?.find((item) => item.product_item_id === selectedProductItemID);
  const disabled = (!selectedProduct?.in_stock && !context?.allowPrescriptionOnlyFlow && !selectedProduct?.is_pre_orderable) || context?.isSubmitButtonDisabled;
  
  const isColLayout = products.find((product) => {
    const productTitle = product.dosage_str || product.product_title;
    return productTitle.length > 8
  }) !== undefined || COL_DESIGN_COUNTRIED.includes(context?.countryID?.toUpperCase() || '');

  if (!context?.languageID){
    return <></>
  }

  return (
    <div id='treatment-selection' className='p-5 flex flex-col gap-4 rounded-md w-full bg-white overflow-x-hidden'>
      
      {!context?.isNoPreferenceSelected && (
        <div className="w-full flex flex-col items-center justify-center">
          <p
            className='mini-title font-bold text-center break-words max-w-full'
            id='drug-title'
            style={{ wordBreak: "break-word", whiteSpace: "pre-line", ...(context?.selectedProduct?.is_pre_orderable && !plans ? { paddingBottom: 0 } : {}) }}
          >
            {titleWithDosageForm(context?.selectedProduct?.title || '', context?.selectedProduct, context?.languageID)}
          </p>
          {context?.selectedProduct?.is_pre_orderable && !plans && (
            <>
              <span className="font-poppins font-medium text-[14px] leading-[20px] text-white bg-[#269c6e] px-3 py-[2px] rounded-md text-center mt-[4px]">
                {translator.translate(context.languageID, "choose_treatment", "pre_order_market_date")}
              </span>
              <p className="font-poppins text-[14px] text-[#0d2c54] opacity-40 text-center leading-[1.3] mt-1">
                {translator.translate(context.languageID, "choose_treatment", "pre_order_market_description")}
              </p>
            </>
          )}
        </div>
      )}

      {!plans && !context?.selectedProduct?.is_pre_orderable && Boolean(selectedItem?.in_stock) && (
        isExpressProductItem
          ? <img className='w-full -mt-8' src={clientConfig.IMAGES_URL + "static_images/ExpressDeliveryTimes.svg"} width="120" height="28" alt="ExpressDeliveryTimes" />
          : <img className='w-full -mt-8' src={clientConfig.IMAGES_URL + "static_images/RegularDeliveryTimes.svg"} width="65" height="28" alt="RegularDeliveryTimes" />
      )}

      {
        context?.isNoPreferenceSelected ? <NoTreatmentSelectedInfo /> :
          <>
            <DosageSelection isResponsiveLayout={isResponsiveLayout} isColLayout={isColLayout} />

            <ProductItemSelection isResponsiveLayout={isResponsiveLayout} isColLayout={isColLayout} />

            {!routerContext?.showERezeptDisclaimer && <SubscriptionSelection isResponsiveLayout={isResponsiveLayout} />}
          </>
      }

      <SubmitButton languageID={context!.languageID} onClick={() => context?.onSubmit()} desktop={!isResponsiveLayout} disabled={disabled}/>
      {selectedProduct?.product_settings?.disclaimer &&
        <div className='flex items-center justify-center mt-2 px-2'>
          <p className='text-xs text-gray-500 text-center leading-tight'>
            {selectedProduct?.product_settings?.disclaimer}
          </p>
        </div>
      }
    </div>
  )
}

export default TreatmentSelection
